import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppVersionResponseDto } from './app-version.dto';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppVersionModalService {
  private baseUrl: string = environment.apiServer + '/AppVersion';
  private readonly headers = new HttpHeaders();

  constructor(private httpClient: HttpClient) {
    this.headers = this.headers.set(
      'Content-Type',
      'application/json; charset=utf-8',
    );
  }

  getData(): Observable<AppVersionResponseDto[]> {
    return this.httpClient.get<AppVersionResponseDto[]>(this.baseUrl, {
      headers: this.headers,
    });
  }
}
